import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './AuthContext';
import DotGrid from './DotGrid';
import LoginRegister from './LoginRegister';
import './HeroPage.css';

const HeroPage = () => {
  const { user } = useAuth();
  const [showLogin, setShowLogin] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    days: '00',
    hours: '00',
    minutes: '00',
    seconds: '00'
  });

  useEffect(() => {
    const updateCountdown = () => {
      const eventDate = new Date('2026-01-30T09:00:00').getTime();
      const now = new Date().getTime();
      const distance = eventDate - now;

      if (distance > 0) {
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        setTimeLeft({
          days: days.toString().padStart(2, '0'),
          hours: hours.toString().padStart(2, '0'),
          minutes: minutes.toString().padStart(2, '0'),
          seconds: seconds.toString().padStart(2, '0')
        });
      }
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero">

      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0, opacity: 0.3 }}>

      </div>
      <spline-viewer
        url="https://prod.spline.design/nQMJIg-2ISdxMLjs/scene.splinecode"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 1
        }}
      ></spline-viewer>

      <div className="hero-content">
        <h1 className="hero-title">CRYPTERA 2K26</h1>
        <p className="hero-tagline">You know the technology, We shape the impact.</p>

        <div className="countdown" id="countdown">
          <div className="time-unit">
            <span id="days">{timeLeft.days}</span>
            <label>Days</label>
          </div>
          <div className="time-unit">
            <span id="hours">{timeLeft.hours}</span>
            <label>Hours</label>
          </div>
          <div className="time-unit">
            <span id="minutes">{timeLeft.minutes}</span>
            <label>Minutes</label>
          </div>
          <div className="time-unit">
            <span id="seconds">{timeLeft.seconds}</span>
            <label>Seconds</label>
          </div>
        </div>



        <div className="hero-buttons">
          {!user && (
            <button className="btn primary" onClick={() => setShowLogin(true)}>
              Register Now
            </button>
          )}
          <Link to="/events" className={`btn secondary ${user ? 'btn-full-width' : ''}`}>
            Explore Events
          </Link>
        </div>
      </div>
      {showLogin && <LoginRegister onClose={() => setShowLogin(false)} />}
    </section>
  );
};

export default HeroPage;